import { Injectable, inject, computed } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { TenantService } from './tenant.service';
import { NavigationItem } from '../../shared/interfaces/navigation-item.interface';
import { hasMinRole } from '../auth/role.model';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private readonly authService = inject(AuthService);
  private readonly tenantService = inject(TenantService);

  public readonly ALL_MENUS: NavigationItem[] = [
    { label: '組織一覧', icon: 'corporate_fare', route: '/organizations', minRole: 'super_admin' },
    { label: '管理部署', icon: 'domain', route: '/departments', minRole: 'org_admin' },
    { label: 'センサー管理', icon: 'sensors', route: '/sensors', minRole: 'org_admin' },
    { label: '現場一覧', icon: 'view_list', route: '/sites/list', minRole: 'dep_admin' },
    { label: '現場マップ', icon: 'map', route: '/sites/map', minRole: 'dep_admin' },
    { label: '現場管理', icon: 'settings_system_daydream', route: '/sites/manage', minRole: 'org_admin' },
    { label: 'ユーザー管理', icon: 'people', route: '/accounts/list', minRole: 'org_admin' },
    { label: 'データ抽出', icon: 'file_download', route: '/data/extract', minRole: 'site_manager', requiredFeature: 'sensor_extract' },
    { label: 'データDL', icon: 'download', route: '/data/download', minRole: 'site_manager' },
    { label: '高度な分析', icon: 'analytics', route: '/analytics', requiredFeature: 'advanced_analytics' },
    { label: '組織設定', icon: 'settings', route: '/settings/org', minRole: 'org_admin', excludeRoles: ['super_admin'] },
    { label: 'アクセスログ', icon: 'manage_search', route: '/data/access-log', minRole: 'super_admin' },
    { label: 'システム管理', icon: 'admin_panel_settings', route: '/admin', minRole: 'super_admin' },
  ];

  public readonly menus = computed(() => {
    const userRole = this.authService.userRole();
    // 依存関係を明示的にトラッキングさせるため、TenantService のシグナルを読み込む
    void this.tenantService.organization();
    
    return this.ALL_MENUS.filter(item => {
      // Role check
      if (item.minRole && !hasMinRole(userRole, item.minRole)) {
        return false;
      }

      if (userRole && item.excludeRoles?.includes(userRole)) {
        return false;
      }
      
      // Feature flag check
      if (item.requiredFeature && !this.tenantService.hasFeature(item.requiredFeature)) {
        return false;
      }
      
      return true;
    });
  });
}
